import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
    textarea[data-testid="aquila-issueDescription-textarea"] {
        height: 100px;
        width: 600px;
    }
`;

export default GlobalStyle;
